import classNames from 'classnames'
import { ErrorMessage, useField } from 'formik'

import type { ReactElement } from 'react'
import type { Props as SelectProps } from 'react-select'

import BasicSelectInput from '../../Basic/SelectInput'

import CustomOption from '~/components/SelectOptions/CustomOption'

import '../../input-common.scss'

interface Props extends Omit<SelectProps, 'isDisabled' | 'isMulti' | 'onChange'> {
  className?: string
  disabled?: boolean
  focus?: boolean
  label?: string
  labelPosition?: 'left' | 'top'
  menuClassName?: string
  name: string
  onChange?: (value: IOption[] | IOption) => void
}

const SelectInput = ({ className, focus, name, onChange, ...props }: Props): ReactElement => {
  const [field, { error, touched }, { setValue }] = useField<IOption[] | IOption>(name)

  const handleChange = (value: IOption[] | IOption) => {
    setValue(value)
    onChange && onChange(value)
  }

  return (
    <div className={classNames('input-component select-input-component input-container', className)}>
      <div className={classNames('field-container', { erroneous: touched && error })}>
        <BasicSelectInput
          {...field}
          {...props}
          autoFocus={focus}
          className={classNames('select-input input-wrapper', { erroneous: touched && error })}
          closeMenuOnSelect
          components={{ Option: CustomOption, ...props.components }}
          name={name}
          onChange={(value: unknown) => handleChange(value as IOption[])}
        />
      </div>
      {touched && error ? <ErrorMessage className="error-message" component="span" name={name} /> : null}
    </div>
  )
}

export default SelectInput
